import { render, staticRenderFns } from "./IconShare.vue?vue&type=template&id=524f2894&scoped=true"
import script from "./IconShare.vue?vue&type=script&lang=js"
export * from "./IconShare.vue?vue&type=script&lang=js"
import style0 from "./IconShare.vue?vue&type=style&index=0&id=524f2894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524f2894",
  null
  
)

export default component.exports